<!--财务中心 客户结算(自录客户) 客户列表-->
<template>
  <div>
    <el-row>
      <el-col>
        <el-form :model="searchForm" ref="searchForm" :inline="true" style="margin-top: 20px">
          <el-form-item label="项目点：">
            <el-select size="medium" filterable v-model="searchForm.PROJECT" placeholder="请选择" clearable
              @change="getProject">
              <el-option v-for="item in points" :key="item.value" :label="item.AB_NAME" :value="item.ID"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="送货日期：">
            <el-date-picker size="medium" v-model="searchForm.DAY_INTERVAL" type="daterange" align="right" unlink-panels
              range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" :picker-options="pickerOptions"
              value-format="yyyy-MM-dd"></el-date-picker>
          </el-form-item>
          <el-form-item>
            <el-button size="medium" type="primary" @click="doQueryTable()" :loading="lodaing">筛选</el-button>
            <el-button size="medium" type="primary" plain class="btn" @click="exportOrder">导出</el-button>
            <el-button size="medium" type="primary" plain class="btn" @click="dayDetailfun">导出明细</el-button>
          </el-form-item>
        </el-form>
      </el-col>
    </el-row>
    <el-row>
      <el-col>
        <el-table :data="balanceOrderList" border stripe show-summary style="width: 100%">
          <el-table-column type="index" width="50" min-width="30" label="序号"></el-table-column>
          <el-table-column prop="ORDER_CODE" label="订单编号" min-width="200"></el-table-column>
          <el-table-column prop="SEND_DAY" label="送货日期" min-width="135"></el-table-column>
          <el-table-column prop="TC_NAME" label="公司" min-width="90"></el-table-column>
          <el-table-column prop="PROJECT_NAME" label="项目点" min-width="90"></el-table-column>
          <el-table-column prop="DK_NAME" label="档口" min-width="90"></el-table-column>
          <el-table-column prop="TOTAL_SUPPLIER_FEE" label="金额" min-width="100"></el-table-column>
          <el-table-column fixed="right" label="操作" width="300">
            <template slot-scope="scope">
              <el-button type="text" size="small" icon="el-icon-view" @click="detail(scope.row)">查看</el-button>
              <el-button type="text" size="small" v-if="showLable(scope.row) !== 0" icon="el-icon-message"
                @click="send(scope.row)">寄单</el-button>
              <el-button type="text" size="small" v-if="showLable(scope.row) !== 0" icon="el-icon-message"
                @click="orderContract(scope.row)">订单资质</el-button>
              <el-button type="text" size="small" icon="el-icon-download" @click="exportCostTable(scope.row)">导出成本表
              </el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-col>
      <el-col :span="24" style="text-align: right">
        <el-pagination @current-change="handleCurrentChange" :current-page.sync="currentPage" :page-size="pageSize"
          layout="total,prev, pager, next, jumper" :total="totalCount"></el-pagination>
      </el-col>
    </el-row>
  </div>
</template>
<script>
import {
  OrderDetailFun, getTCTitle, sendOrderFun, exportCostFun,
} from 'api/tcBanlance';
// import {dayDetail} from 'api/tcBanlance'
import http from '@/assets/common/http';
import util from '@/assets/common/util';

export default {
  data() {
    return {
      pickerOptions: [],
      balanceOrderList: [],
      lodaing: false,
      points: [],
      totalFree: '',
      tcStatus: '',
      searchForm: {
        PROJECT: '',
      },
      status: '',
      totalCount: 0,
      pageSize: 10,
      totalCost: 0,
    };
  },
  created() {
    // 这里用来在设置中设置页面展示条目，文件在setting的generalSettings中，由前端控制条目，存储于localStorage中，key为SMP_PAGE_COUNT
    this.pageSize = Number(localStorage.getItem('SMP_PAGE_COUNT')) ? Number(localStorage.getItem('SMP_PAGE_COUNT')) : 10;
    if (this.ORDER_LIST_CONDITION.CONDITION) {
      // this.searchForm = this.ORDER_LIST_CONDITION.CONDITION;
      this.currentPage = this.ORDER_LIST_CONDITION.CURRENT_PAGE;
    } else {
      this.currentPage = 1;
    }
    this.queryData();
    this.queryTitle();
  },
  computed: {
    ORDER_LIST_CONDITION() {
      return this.$store.state.ORDER_LIST_CONDITION;
    },
  },
  methods: {
    handleCurrentChange() {
      this.queryData();
    },
    // --------------------------------------------导出成本表
    exportCostTable(row) {
      if (document.body.style.cursor === 'wait') {
      } else {
        document.body.style.cursor = 'wait';
        try {
          const params = {
            ORDER_ID: Number(row.ORDER_ID),
          };
          exportCostFun(params).then((result) => {
            if (result.length === 0) {
              this.$message.show({ text: '暂无数据', type: 'warning' });
            } else {
              window.location.href = this.$util.getURLLocalHost(result[0].FILE_PATH);
              document.body.style.cursor = 'default';
            }
          }).catch((error) => {
            this.$message.show({ text: error, type: 'error' });
            document.body.style.cursor = 'default';
          });
        } finally { }
      }
    },
    // ----------------------------------------项目点触发
    getProject(e) {
      this.searchForm.PROJECT_ID = e;
    },
    queryTitle() {
      const data = {
        TC_ID: Number(sessionStorage.getItem('tcID')),
      };
      getTCTitle(data).then((result) => {
        this.points = result.length > 0 ? result[0].list : [];
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    // ----------------------------------------寄单
    send(row) {
      if (document.body.style.cursor === 'wait') {
      } else {
        document.body.style.cursor = 'wait';
        try {
          const params = {
            ORDER_ID: Number(row.ORDER_ID),
          };
          sendOrderFun(params).then((result) => {
            this.$message.show({ text: '操作成功', type: 'success' });
            this.queryData();
            document.body.style.cursor = 'default';
          }).catch((error) => {
            this.$message.show({ text: error, type: 'error' });
            document.body.style.cursor = 'default';
          });
        } finally { }
      }
    },
    // ----------------------------------------判断寄单状态
    showLable(row) {
      switch (row.ORDER_STATUS) {
        case '已确认':
          return '寄单';
        default:
          return 0;
      }
    },
    // ----------------------------------------订单资质
    orderContract(row) {
      this.$router.push({ path: '/settlementOrderContract/detail' });
      sessionStorage.setItem('ORDER_ID', row.ORDER_ID);
    },
    // ----------------------------------------拉取数据
    queryData() {
      const params = {
        TC_ID: Number(sessionStorage.getItem('tcID')),
        MONTH: sessionStorage.getItem('MONTH'),
        PAGEINDEX: this.currentPage - 1,
        PAGESIZE: this.pageSize,
      };
      if (this.searchForm.DAY_INTERVAL) {
        params.START_DAY = this.searchForm.DAY_INTERVAL[0];
        params.END_DAY = this.searchForm.DAY_INTERVAL[1];
      }
      if (this.searchForm.SEND_DAY) {
        params.SEND_DAY = this.searchForm.SEND_DAY;
      }
      if (this.searchForm.PROJECT) {
        params.PROJECT_ID = this.searchForm.PROJECT;
      }
      this.lodaing = true;
      OrderDetailFun(params)
        .then((result) => {
          this.totalFree = sessionStorage.getItem('COST');
          if (result.length !== 0) {
            this.balanceOrderList = result[0].list;
            this.totalCount = result[0].TOTAL_COUNT;
            this.$store.dispatch('SET_ORDER_LIST_CONDITION', {
              // CONDITION: this.searchForm,
              CURRENT_PAGE: this.currentPage,
            });
            this.tcStatus = sessionStorage.getItem('tcStatus');
            this.balanceOrderList.forEach((element) => { // tableData你的数据源
              switch (element.ORDER_STATUS) {
                case 7:
                  element.ORDER_STATUS = '已确认';
                  break;
                case 8:
                  element.ORDER_STATUS = '已寄单';
                  break;
                case 9:
                  element.ORDER_STATUS = '部分收单';
                  break;
                case 10:
                  element.ORDER_STATUS = '全量收单';
                  break;
                default:
                  element.ORDER_STATUS = '状态未翻译';
              }
              // --------------------------------ORDER_STATUS
              this.status = element.ORDER_STATUS;
            });
          } else {
            this.totalCount = 0;
            this.balanceOrderList = [];
            this.$message.show({ text: '暂无数据', type: 'success' });
          }
          this.lodaing = false;
        }).catch((error) => {
          this.lodaing = false;
          this.$message.show({ text: error, type: 'error' });
        });
    },
    detail(row) {
      this.$router.push({ path: '/customerOrderDayList/detail' });
      sessionStorage.setItem('ORDER_ID', row.ORDER_ID);
    },
    // --------------------------搜索
    doQueryTable() {
      this.currentPage = 1;
      this.queryData();
    },
    // 导出明细
    dayDetailfun() {
      const params = {
        SERVICE_ID: '10009',
        OTYPE: 49,
        TC_ID: Number(sessionStorage.getItem('tcID')),
        GYS_ID: Number(sessionStorage.getItem('tcId')),
      };
      if (this.searchForm.PROJECT) {
        params.PROJECT_ID = this.searchForm.PROJECT;
      }
      if (this.searchForm.DAY_INTERVAL && this.searchForm.DAY_INTERVAL[0]) {
        params.START_DAY = this.searchForm.DAY_INTERVAL[0];
        params.END_DAY = this.searchForm.DAY_INTERVAL[1];
      }
      http.post(params).then((res) => {
        window.location.href = util.getURLLocalHost(res[0].FILE_PATH);
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    // 导出
    exportOrder() {
      const params = {
        SERVICE_ID: '10009',
        OTYPE: 54,
        TC_ID: Number(sessionStorage.getItem('tcID')),
        GYS_ID: Number(sessionStorage.getItem('tcId')),
        MONTH: sessionStorage.getItem('MONTH'),
      };
      if (this.searchForm.PROJECT) {
        params.PROJECT_ID = this.searchForm.PROJECT;
      }
      if (this.searchForm.DAY_INTERVAL && this.searchForm.DAY_INTERVAL[0]) {
        params.START_DAY = this.searchForm.DAY_INTERVAL[0];
        params.END_DAY = this.searchForm.DAY_INTERVAL[1];
      }
      http.post(params).then((res) => {
        window.location.href = util.getURLLocalHost(res[0].FILE_PATH);
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/financeCenter/customerOrderList.vue